export default __webpack_public_path__ + "static/media/chainlink@2x.9dd80617.png";